import Button from '../components/common/Button';
import ContactCTA from '../components/common/ContactCTA';
import { industries } from '../data/industries';
import { services } from '../data/services';

const workPrinciples = [
  {
    title: 'Repair-first thinking',
    text: 'We look at the equipment, failure symptoms, and practical repair path before assuming replacement is the right answer.',
  },
  {
    title: '1-year warranty',
    text: 'Repair work is backed by a 1-year warranty, giving industrial customers a clearer path after the component returns to service.',
  },
  {
    title: 'Fast emergency support',
    text: 'Turnaround depends on the repair scope and parts, but urgent breakdowns and emergency repair needs are handled as quickly as possible.',
  },
  {
    title: 'Pickup and shipping support',
    text: 'Free pickup and shipping support helps make the repair process easier for customers across Canada.',
  },
  {
    title: 'Experienced team',
    text: 'Our team brings 15 years of combined industrial repair experience across gearbox, hydraulic, and related mechanical work.',
  },
];

function About() {
  return (
    <>
      <section className="about-page-hero" aria-labelledby="about-page-title">
        <div className="container about-page-hero__inner">
          <div className="about-page-hero__copy">
            <p className="eyebrow">About</p>
            <h1 id="about-page-title">Industrial repair support for gearboxes and hydraulics</h1>
            <p>
              We provide industrial gearbox and hydraulic repair support for customers across Canada. Our work is
              focused on practical repairs for equipment that needs to get back into service, with emergency repair
              support, free pickup and shipping, and 1-year warranty coverage.
            </p>
            <div className="about-page-hero__actions">
              <Button to="/services">View Services</Button>
              <Button href="tel:+14374357083" variant="secondary">
                Call (437) 435-7083
              </Button>
            </div>
          </div>
          <div
            className="about-page-hero__image"
            style={{ '--about-page-image': `url(${process.env.PUBLIC_URL}/images/landing-img4.png)` }}
            aria-label="Industrial repair work"
          />
        </div>
      </section>

      <section className="about-page-section">
        <div className="container about-page-section__grid">
          <div>
            <p className="eyebrow">What We Do</p>
            <h2>Focused repair services</h2>
          </div>
          <div className="about-page-card-grid">
            {services.map((service) => (
              <article key={service.id} className="about-page-card">
                <img src={`${process.env.PUBLIC_URL}${service.icon}`} alt="" aria-hidden="true" />
                <h3>{service.title}</h3>
                <p>{service.summary}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="about-page-section about-page-section--muted">
        <div className="container about-page-section__grid">
          <div>
            <p className="eyebrow">How We Work</p>
            <h2>Practical support from the first conversation</h2>
          </div>
          <div className="about-page-principles">
            {workPrinciples.map((item) => (
              <article key={item.title} className="about-page-principle">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="about-page-section">
        <div className="container about-page-section__grid">
          <div>
            <p className="eyebrow">Industries</p>
            <h2>Built for industrial environments</h2>
            <p>
              Gearbox and hydraulic problems show up across many types of equipment. We support repair inquiries from
              industrial customers across Canada.
            </p>
          </div>
          <div className="about-page-industries">
            {industries.map((industry) => (
              <article key={industry.id} className="about-page-industry">
                <img src={`${process.env.PUBLIC_URL}${industry.icon}`} alt="" aria-hidden="true" />
                <div>
                  <h3>{industry.title}</h3>
                  <p>{industry.summary}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="about-page-value">
        <div className="container about-page-value__inner">
          <p className="eyebrow">Why Repair Matters</p>
          <h2>Repair can keep critical equipment moving</h2>
          <p>
            Rebuilding or repairing an industrial component can be a practical path when replacement is expensive,
            delayed, or unnecessary. A focused repair review helps identify what failed, what can be corrected, and what
            information is needed before work moves ahead.
          </p>
          <Button to="/contact" variant="outline-light">
            Request a Repair Quote
          </Button>
        </div>
      </section>

      <ContactCTA />
    </>
  );
}

export default About;
